import accounting from './accounting.json';
import admin from './admin.json';
import common from './common.json';
import componentLibrary from './componentLibrary.json';
import dashboard from './dashboard.json';
import deposits from './deposits.json';
import directory from './directory.json';
import directoryManager from './directoryManager.json';
import documents from './documents.json';
import error from './error.json';
import faTrustBankingCard from './faTrustBankingCard.json';
import forgotPasswordForm from './forgotPasswordForm.json';
import funding from './funding.json';
import fundingAdmin from './fundingAdmin.json';
import geo from './geo.json';
import hierarchy from './hierarchy.json';
import imageUploader from './imageUploader.json';
import insights from './insights.json';
import integrationMarketplace from './integrationMarketplace.json';
import knowledgeBase from './knowledgeBase.json';
import main from './main.json';
import noResults from './noresults.json';
import notes from './notes.json';
import orders from './orders.json';
import parties from './parties.json';
import payoffs from './payoffs.json';
import premiumFees from './premiumFees.json';
import profile from './profile.json';
import profileMenu from './profileMenu.json';
import reconciliationCard from './reconciliationCard.json';
import reports from './reports.json';
import securePortal from './securePortal.json';
import settlements from './settlements.json';
import shipping from './shipping.json';
import titles from './titles.json';
import titlesAdmin from './titlesAdmin.json';
import users from './users.json';
import validation from './validation.json';
import viewReport from './viewReport.json';
import workflow from './workflow.json';
import workflowAdmin from './workflowAdmin.json';

export default {
  accounting,
  common,
  admin,
  validation,
  main,
  profile,
  orders,
  componentLibrary,
  funding,
  fundingAdmin,
  settlements,
  deposits,
  directory,
  users,
  documents,
  premiumFees,
  profileMenu,
  reports,
  securePortal,
  geo,
  shipping,
  titles,
  titlesAdmin,
  hierarchy,
  payoffs,
  parties,
  knowledgeBase,
  imageUploader,
  directoryManager,
  workflowAdmin,
  notes,
  forgotPasswordForm,
  workflow,
  dashboard,
  integrationMarketplace,
  insights,
  error,
  faTrustBankingCard,
  reconciliationCard,
  noResults,
  viewReport,
} as const;
